// removed by extract-text-webpack-plugin
module.exports = {"content":"FollowUp30Day__content__2SjoU","parentContainer":"FollowUp30Day__parentContainer__hYJXt","searchWrapper":"FollowUp30Day__searchWrapper__23LCg","searchWrapperLabel":"FollowUp30Day__searchWrapperLabel__fPLLv"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/FollowUp30Day/FollowUp30Day.css
// module id = 2902
// module chunks = 0